import { render, staticRenderFns } from "./VisibilidadeDeColunas.vue?vue&type=template&id=8e05d5ec&scoped=true"
import script from "./VisibilidadeDeColunas.vue?vue&type=script&lang=js"
export * from "./VisibilidadeDeColunas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e05d5ec",
  null
  
)

export default component.exports